import { Helmet } from 'react-helmet-async';

const Favicon = () => {
  return (
    <Helmet>
      <link rel="icon" type="image/png" href={`${process.env.PUBLIC_URL}/favicon.ico`} />
      <link rel="apple-touch-icon" href={`${process.env.PUBLIC_URL}/apple-touch-icon.png`} />
      <link rel="manifest" href={`${process.env.PUBLIC_URL}/site.webmanifest`} />
    </Helmet>
  );
};

export default Favicon; 